import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import useQuery from 'hooks/useQuery';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import Input from 'v3/components/Input';

function Filter({ onChange }) {
  const query = useQuery();
  const navigate = useNavigate();

  const [filter, setFilter] = useState({});

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate({ search: query.toString() });
    }, 150);

    return () => {
      clearTimeout(timeout);
    };
  }, [filter]);

  return (
    <Row className="align-items-end mb-4">
      <Col md={11} xs={12} className="mb-3">
        <Input
          label="Produto"
          labelColor="#fff"
          value={filter.search}
          placeholder="Digite o nome do produto"
          onChange={({ target }) => {
            if (target.value === null || target.value === '') {
              query.delete('search');
            } else {
              query.set('search', target.value);
            }
            setFilter((old) => ({ ...old, search: target.value }));
          }}
        />
      </Col>

      <Col md={1} xs={12} className="d-flex align-items-end mb-3 ps-2">
        <Button
          variant="success"
          onClick={() => {
            onChange();
          }}
        >
          <Text type="regular" weight={500}>
            Filtrar
          </Text>
        </Button>
      </Col>
    </Row>
  );
}

export default Filter;
